import React, { useEffect, useRef, useState } from "react";
import { CUP_NAME_REGEX } from "./cupConstants";

export default function CupRenameInput({
  initialValue = "",
  onSave,
  onCancel,
  existingNames = [],
}) {
  const [value, setValue] = useState(initialValue);
  const [error, setError] = useState(null);
  const inputRef = useRef(null);

  useEffect(() => {
    inputRef.current?.focus();
    inputRef.current?.select();
  }, []);

  const validate = (v) => {
    const trimmed = v.trim();
    if (!trimmed) return "İsim boş olamaz";
    if (!CUP_NAME_REGEX.test(trimmed)) return "Tek kelime, en çok 7 karakter";
    if (existingNames.includes(trimmed)) return "Bu isim zaten var";
    return null;
  };

  const handleSave = () => {
    const err = validate(value);
    if (err) {
      setError(err);
      return;
    }
    onSave(value.trim());
  };

  return (
    <div className="flex flex-col gap-1">
      <div className="flex items-center gap-1">
        <input
          ref={inputRef}
          type="text"
          maxLength={7}
          value={value}
          onChange={(e) => {
            setValue(e.target.value);
            setError(null);
          }}
          onKeyDown={(e) => {
            if (e.key === "Enter") handleSave();
            if (e.key === "Escape") onCancel();
          }}
          className="border rounded px-2 py-1 w-24 text-sm"
        />
        <button
          type="button"
          onClick={handleSave}
          className="text-green-600 px-1"
        >
          ✓
        </button>
        <button type="button" onClick={onCancel} className="text-red-600 px-1">
          ✗
        </button>
      </div>
      {error && <span className="text-xs text-red-600">{error}</span>}
    </div>
  );
}
